
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as icons_45pageA2HjB8z1HfHkncM2uYCwG_45u5Cf3y9wQBqU0xcTuIkU0Meta } from "/builds/kassir/website/node_modules/@nuxtjs/svg-sprite/dist/runtime/components/icons-page.vue?macro=true";
import { default as _404j2m6rGaYEVKXqkl5cKwPelqwYA9KY9OTiDSeYMCZbnYMeta } from "/builds/kassir/website/widget/pages/404.vue?macro=true";
import { default as indexXCWt_WiJYWXHmgSDXok54favrmIswbct14qynBwqEcgMeta } from "/builds/kassir/website/widget/pages/index.vue?macro=true";
import { default as _91_46_46_46slug_93P7rXH8_458GB6w8C1yjhJIyX0eUMpnRpWfQaR3zJjXuNIMeta } from "/builds/kassir/website/widget/pages/[...slug].vue?macro=true";
import { default as thank_you6dZJKwwNRvvRJ6chMKgUeeSoB_454clA2YGmJdAu0SDt4Meta } from "/builds/kassir/website/widget/pages/thank_you.vue?macro=true";
import { default as _91orderId_93074BP9eUamKVJ_45JMisel__45lcv0rd7uASd9kIfsxTwaQMeta } from "/builds/kassir/website/widget/pages/orders/view/[orderId].vue?macro=true";
import { default as missing_45url_45query_45paramsnhWycB68VLjR8jwKHywEWRE7aPYEypVt1F5Hf45RnDIMeta } from "/builds/kassir/website/widget/pages/missing-url-query-params.vue?macro=true";
import { default as _91orderId_93SqpMyvzY3vtIvZ3JQG9nIFoTgk3aDcVMrs4tBRgx4HAMeta } from "/builds/kassir/website/widget/pages/orders/processing/[orderId].vue?macro=true";
export default [
  {
    name: "icons-page",
    path: "/_icons",
    meta: {"layout":"svg-sprite"},
    component: () => import("/builds/kassir/website/node_modules/@nuxtjs/svg-sprite/dist/runtime/components/icons-page.vue")
  },
  {
    name: "404",
    path: "/404",
    meta: _404j2m6rGaYEVKXqkl5cKwPelqwYA9KY9OTiDSeYMCZbnYMeta || {},
    component: () => import("/builds/kassir/website/widget/pages/404.vue")
  },
  {
    name: "index",
    path: "/",
    meta: indexXCWt_WiJYWXHmgSDXok54favrmIswbct14qynBwqEcgMeta || {},
    component: () => import("/builds/kassir/website/widget/pages/index.vue")
  },
  {
    name: "slug",
    path: "/:slug(.*)*",
    meta: _91_46_46_46slug_93P7rXH8_458GB6w8C1yjhJIyX0eUMpnRpWfQaR3zJjXuNIMeta || {},
    component: () => import("/builds/kassir/website/widget/pages/[...slug].vue")
  },
  {
    name: "thank_you",
    path: "/thank_you",
    meta: thank_you6dZJKwwNRvvRJ6chMKgUeeSoB_454clA2YGmJdAu0SDt4Meta || {},
    component: () => import("/builds/kassir/website/widget/pages/thank_you.vue")
  },
  {
    name: "orders-view-orderId",
    path: "/orders/view/:orderId()",
    meta: _91orderId_93074BP9eUamKVJ_45JMisel__45lcv0rd7uASd9kIfsxTwaQMeta || {},
    component: () => import("/builds/kassir/website/widget/pages/orders/view/[orderId].vue")
  },
  {
    name: "missing-url-query-params",
    path: "/missing-url-query-params",
    meta: missing_45url_45query_45paramsnhWycB68VLjR8jwKHywEWRE7aPYEypVt1F5Hf45RnDIMeta || {},
    component: () => import("/builds/kassir/website/widget/pages/missing-url-query-params.vue")
  },
  {
    name: "orders-processing-orderId",
    path: "/orders/processing/:orderId()",
    meta: _91orderId_93SqpMyvzY3vtIvZ3JQG9nIFoTgk3aDcVMrs4tBRgx4HAMeta || {},
    component: () => import("/builds/kassir/website/widget/pages/orders/processing/[orderId].vue")
  }
]